import { Component, OnInit, OnDestroy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Observable, Subject } from 'rxjs'
import { finalize, switchMap, takeUntil, tap } from 'rxjs/operators'

import { AuthService } from '../auth.service'
import { PlatformSettings } from '@shared/models/platform-settings.model'
import { PlatformSettingsService } from '@core/services/platfrom-settings.service'
import { CLIENT_LANDING_URL } from '@core/constants/team-type'

@Component({
  selector: 'lin-one-time-password',
  templateUrl: './one-time-password.component.html',
  styleUrls: ['./one-time-password.component.scss'],
  standalone: false,
})
export class OneTimePasswordComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<void>()
  form: FormGroup
  formError: string
  isSubmitting = false
  phoneNumber: string
  platformSettings$: Observable<PlatformSettings>

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private readonly platformSettingsService: PlatformSettingsService,
  ) {}

  ngOnInit() {
    this.createForm()

    this.phoneNumber = this.authService.getCurrentUserPhone()
    this.platformSettings$ = this.platformSettingsService.platformSettings$
  }

  createForm() {
    this.form = this.fb.group({
      verificationCode: ['', [Validators.required, Validators.minLength(4)]],
    })

    this.form.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.onValueChanged())

    this.onValueChanged()
  }

  onValueChanged() {
    this.formError = ''
  }

  onSubmit() {
    this.formError = ''
    this.isSubmitting = true

    this.authService
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
      .verifyOtp(this.authService.getCurrentUserEmail(), this.form.value.verificationCode)
      .pipe(
        switchMap((data) =>
          this.authService.setAuth(data).pipe(
            tap(() => {
              // L30-1495: client users land on the v2 client app; admin and reseller keep their pages.
              const redirectUrl = data['teamType'] === 'admin' ? 'admin' : data['teamType'] === 'client' ? CLIENT_LANDING_URL : 'client'
              void this.router.navigate([redirectUrl])
            }),
          ),
        ),
        finalize(() => (this.isSubmitting = false)),
      )
      .subscribe(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
        (error) => (this.formError = error.error.errors[0].detail),
      )
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
